import { render, staticRenderFns } from "./AppointmentSuccessModal.vue?vue&type=template&id=b9e77cc4&"
import script from "./AppointmentSuccessModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentSuccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports